

import { useState } from "react";
import Config from "../../Config";

 

//import Start from "./Start";
//import Group from "./Group";
import Kids from "./Kids"; 
import Alerts from "./Alerts"; 
import Book from "./Book"; 
import Free from "../kids/Free"; 
//import FreeSettings from "./FreeSettings";
//import Overhour from "./Overhour";
//import Hour from "./Hour";
import InOutE from "./InOut";
import InOutM from "./InOutM";
//import NoticeOnline from "./NoticeOnline";
import Layette from "./Layette";
import LayetteM from "./LayetteM";
import LayetteNew from "./LayetteNew.js";
import LessonExtra from "../kids/LessonExtra.js";


function View(props)
{

 

    const [refreshView, setRefreshView] = useState(props.userData.refreshView);

 
 

    if(refreshView != props.userData.refreshView)
    {
        setRefreshView( props.userData.refreshView);   
    }



    
    var tab0 = " m_item ";
    var tab1 = " m_item ";
    var tab2 = " m_item ";
    var tab3 = " m_item ";
    var tab4 = " m_item ";
    var tab5 = " m_item ";
    var tab6 = " m_item ";
   

    
    if(props.mainView.viewSelected == "kids") tab0 = tab0 + " selected";
    if(props.mainView.viewSelected == "FreeE") tab1 = tab1 + " selected";
    if(props.mainView.viewSelected == "InoutE") tab2 = tab2 + " selected";
    if(props.mainView.viewSelected == "alerts") tab3 = tab3 + " selected";
    if(props.mainView.viewSelected == "book") tab4 = tab4 + " selected";
    if(props.mainView.viewSelected == "layette") tab5 = tab5 + " selected";
    if(props.mainView.viewSelected == "layette") tab6 = tab6 + " selected";
    

    var subMenu = <div className="submenu">
            <div className={tab0} module="kidsE" view="kids" id="" onClick={props.mainView.quickGo} >Dzieci</div>
            <div className={tab2}  module="kidsE" view="InoutE" id="" onClick={props.mainView.quickGo} >Wejścia&nbsp;i&nbsp;wyjścia</div>
            <div className={tab1}  module="kidsE" view="FreeE" id="" onClick={props.mainView.quickGo} >Nieobecności</div>
            <div className={tab3}  module="kidsE" view="alerts" id="" onClick={props.mainView.quickGo} >Powiadomienia</div>
            <div className={tab4}  module="kidsE" view="book" id="" onClick={props.mainView.quickGo} >Dzienniczek</div>
            <div className={tab5}  module="kidsE" view="layette" id="" onClick={props.mainView.quickGo} >Wyprawka</div>
            <div className={tab5}  module="kidsE" view="zd" id="" onClick={props.mainView.quickGo} >Zajęcia dodatkowe</div>
    </div>

    var is_mobile = props.mainView.isMobile();

    var table = '';    
   
    
    
 
    /*
    if(props.mainView.viewSelected == 'start' || props.mainView.viewSelected == undefined )
    {
        document.title ="Wyszukiwarka / Dzieci"; 

        return (
            <div className="econtent ">                           
                     {subMenu}      
                  <Start  userData={props.userData}  mainView={props.mainView}  /> 
             </div>
        )
    }

    if(props.mainView.viewSelected == 'group')
    {
        document.title ="Grupy / Dzieci"; 
        return (
            <div className="econtent ">                           
                           {subMenu}      
                  <Group  userData={props.userData}  mainView={props.mainView}  /> 
             </div>
        )
    }
    */

    

    //<KidsE  userData={props.userData}  mainView={props.mainView}  /> 
    if(props.mainView.viewSelected == 'kids' || props.mainView.viewSelected == 'ViewE')
    {

        document.title ="Lista dzieci / Dzieci"; 
        return (
            <div className="econtent ">                           
                {subMenu}    
                <Kids  userData={props.userData}  mainView={props.mainView}  />   
             </div>
        )
    }

    if(props.mainView.viewSelected == 'alerts' )
        {
    
            document.title ="Lista dzieci / Dzieci"; 
            return (
                <div className="econtent ">                           
                    {subMenu}    
                    <Alerts  userData={props.userData}  mainView={props.mainView}  />   
                 </div>
            )
        }

        if(props.mainView.viewSelected == 'book' )
            {
        
                document.title ="Dzienniczek"; 
                return (
                    <div className="econtent ">                           
                        {subMenu}    
                        <Book  userData={props.userData}  mainView={props.mainView}  />   
                     </div>
                )
            }
    
    // 
    if(props.mainView.viewSelected == 'FreeE')
        {
            document.title ="Nieobecności / Dzieci"; 
            return (
                <div className="econtent ">                           
                    {subMenu}  
                    <Free  userData={props.userData}  mainView={props.mainView}  /> 
                    
                      
                 </div>
            )
        }  
        
    /*    
    if(props.mainView.viewSelected == 'over')
            {
                document.title ="Nadgodziny / Dzieci"; 
                return (
                    <div className="econtent ">          
                            {subMenu}                                                      
                          <Overhour  userData={props.userData}  mainView={props.mainView}  /> 
                     </div>
                )
            }           

    if(props.mainView.viewSelected == 'hour')
                {
                    document.title ="Godziny pobytu / Dzieci"; 
                    return (
                         <div className="econtent ">    
                             {subMenu}                                                            
                              <Hour  userData={props.userData}  mainView={props.mainView}  /> 
                         </div>
                    )
                }        
    */     
   
                //
    if(props.mainView.viewSelected == 'InoutE')
    {
    
        if(is_mobile)
        {
            document.title ="Wejścia i wyjścia / Dzieci"; 
            return (
                <div className="econtent ">         
                    {subMenu}                                                       
                    <InOutM  userData={props.userData}  mainView={props.mainView}  />   
                </div>
                )
        }   
        else
        {
            document.title ="Wejścia i wyjścia / Dzieci"; 
            return (
                <div className="econtent ">         
                    {subMenu}                                                       
                    <InOutE  userData={props.userData}  mainView={props.mainView}  />   
                </div>
                )
        } 
        
    }   


    if(props.mainView.viewSelected == 'layette' || props.mainView.viewSelected == 'view')
        {
            document.title ="Wyprawka"; 
        
            if(is_mobile)
            {
                
                return (
                    <div className="econtent ">         
                        {subMenu}                                                      
                        <LayetteM  userData={props.userData}  mainView={props.mainView}  />   
                    </div>
                )
            }   
            else
            {
                
                return (
                    <div className="econtent ">         
                        {subMenu}                                                       
                        <Layette  userData={props.userData}  mainView={props.mainView}  />  
                    </div>
                )
            } 
    
    
    
        }   
        


    if(props.mainView.viewSelected == 'zd' || props.mainView.viewSelected == 'view')
        {
            document.title ="Zajęcia dodatkowe"; 
        
            if(is_mobile)
            {
                
                return (
                    <div className="econtent ">         
                        {subMenu}                                                      
                        <LessonExtra  userData={props.userData}  mainView={props.mainView}  />   
                    </div>
                )
            }   
            else
            {
                
                return (
                    <div className="econtent ">         
                        {subMenu}                                                       
                         <LessonExtra  userData={props.userData}  mainView={props.mainView}  />   
                    </div>
                )
            } 
    
    
    
        }  


    
        if(props.mainView.viewSelected == 'new')
            {
        
               
            document.title ="Nowa wyprawka"; 
    
           
           /*     
            return (
                <div className="econtent ">         
                    {subMenu}                                                       
                    return <LayetteNew  userData={props.userData} mainView={props.mainView} onBack={onBack}    /> 
                </div>
            )
        */
            }

    /*                 
    if(props.mainView.viewSelected == 'online')
                        {
                            document.title ="Zgłoszenia OnLine"; 
                            return (
                                 <div className="econtent ">    
                                     {subMenu}                                                            
                                      <NoticeOnline  userData={props.userData}  mainView={props.mainView}  /> 
                                 </div>
                            )
                        }                       

    */                
    return (
        <div className="econtent">
             { "View, op: " +  props.mainView.viewSelected}
        </div>
    );
    
}

export default View;